export const FROM_DEV = 'fromDev';
export const FROM_GA = 'fromGA';
